import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE } from "../../config/api";
import { authService } from "../../services/auth";
import { httpRequest } from "../../utils/httpClient";
import "./SurveyAdmin.css";

function SurveyAdmin() {
  const navigate = useNavigate();
  const [slug, setSlug] = useState("pista-wtp-pmf");
  const [name, setName] = useState("Pista WTP PMF Survey");
  const [jsonText, setJsonText] = useState("");
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const handleClose = () => navigate("/");

  const handleFileChange = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    const text = await file.text();
    setJsonText(text);
  };

  const handlePublish = async () => {
    setStatus("");
    setLoading(true);
    try {
      if (!slug.trim()) {
        throw new Error("Slug is required.");
      }
      if (!jsonText.trim()) {
        throw new Error("Survey JSON is required.");
      }
      const parsed = JSON.parse(jsonText);
      const res = await httpRequest(`${API_BASE}/admin/surveys/publish`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...authService.getAuthHeaders(),
        },
        body: JSON.stringify({
          slug: slug.trim(),
          name: name.trim() || slug.trim(),
          definition_json: parsed,
        }),
      });

      const payload = await res.json();
      if (!res.ok) {
        throw new Error(payload.detail || "Failed to publish survey.");
      }
      setStatus(`Published version ${payload.version} (${payload.survey_version_id || "ok"}).`);
    } catch (err) {
      setStatus(err.message || "Failed to publish survey.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="survey-admin">
      <div className="survey-admin-header">
        <h2>Admin: Publish Survey</h2>
        <button className="close-button" onClick={handleClose}>
          ×
        </button>
      </div>

      <div className="survey-admin-form">
        <label>
          Slug
          <input value={slug} onChange={(e) => setSlug(e.target.value)} />
        </label>
        <label>
          Name
          <input value={name} onChange={(e) => setName(e.target.value)} />
        </label>
        <label>
          Survey JSON file
          <input type="file" accept="application/json" onChange={handleFileChange} />
        </label>
        <label>
          Survey JSON
          <textarea
            value={jsonText}
            onChange={(e) => setJsonText(e.target.value)}
            rows={12}
            placeholder="Paste SurveyJS JSON here"
          />
        </label>
        <button className="primary-button" onClick={handlePublish} disabled={loading}>
          {loading ? "Publishing..." : "Publish Survey"}
        </button>
        {status ? <div className="survey-admin-status">{status}</div> : null}
      </div>
    </div>
  );
}

export default SurveyAdmin;
